import { render } from "./ToolbarSlot.vue?vue&type=template&id=6480f5e0&scoped=true"
import script from "./ToolbarSlot.vue?vue&type=script&lang=js"
export * from "./ToolbarSlot.vue?vue&type=script&lang=js"

import "./ToolbarSlot.vue?vue&type=style&index=0&id=6480f5e0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6480f5e0"]])

export default __exports__